import React, { useState, useEffect } from 'react'; 
import '../../StylesCSS/LeSeuil.css'; 
import axios from 'axios';
import { useUser } from '../../context/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL } from '../dashboardContent/config'; 
import { useLocation, useNavigate } from 'react-router-dom';
import BranchLabelBanner from './BranchLabelBanner';

const LeSeuil = ({ setActiveSection }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeContext = location.state || {};
  const {
    branch,
    branchLabel,
    action,
  } = routeContext;

  /* Start MSL30082026 */

  const { userId } = useUser(); 
  const [seuil, setSeuil] = useState('');
  const [seuilConfirme, setSeuilConfirme] = useState(null); // Stocke la valeur confirmée
  const [isEditing, setIsEditing] = useState(true); // Contrôle si l'utilisateur est en mode modification
  const [isUpdating, setIsUpdating] = useState(false); // Indique si nous mettons à jour

  const normalizeBranchLabel = (value) => (value == null ? '' : String(value).trim());

  useEffect(() => {
    const fetchSeuil = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/version2/api/seuil/${userId}`, {
          params: {
            branch: branch || '',
            branchLabel: branchLabel || '',
          },
        });
        if (response.data && response.data.seuil !== null) {
          setSeuilConfirme(response.data.seuil);
          setIsEditing(false);
        } else {
          setSeuil('');
          setIsEditing(true);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération du seuil:', error);
      }
    };

    fetchSeuil();
  }, [userId, branch, branchLabel]);

  /* Start MSL30082026 */
  const handleConfirm = async () => {
    try {
      const formData = new URLSearchParams();
      formData.append('seuil', parseFloat(seuil));
      formData.append('userId', userId);
      formData.append('branch', branch || '');
      formData.append('branchLabel', normalizeBranchLabel(branchLabel));

      console.log('=== LeSeuil: confirmation seuil ===');
      console.log('branch:', branch);
      console.log('branchLabel:', branchLabel);
      console.log('formData:', Object.fromEntries(formData.entries()));

      if (isUpdating) {
        // Si nous sommes en mode mise à jour
        await axios.put(`${API_BASE_URL}/version2/api/seuil/update`, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        console.log("عتبة النجاح mise à jour");
      } else {
        // Si c'est la première sauvegarde
        await axios.post(`${API_BASE_URL}/version2/api/seuil/save`, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
        console.log("عتبة النجاح confirmée");
      }

      setSeuilConfirme(seuil); // Stocker la valeur confirmée
      setSeuil(seuil); 
      setIsEditing(false); // Désactiver la modification après confirmation
      setIsUpdating(false); // Désactiver le mode mise à jour
    } catch (error) {
      console.error('Erreur lors de la sauvegarde/mise à jour du seuil:', error);
    }
  };
  /* End MSL30082026 */

  /* Start MSL30082026 */
  const handleEdit = () => {
    setIsEditing(true); // Réactiver la modification
    setIsUpdating(true); // Indiquer que nous sommes en mode mise à jour
  };
  const handleGoBack = (section) => {
    navigate(`/${section}`, {
      state: {
        branch,
        branchLabel,
        action,
      },
    });
  };
  /* End MSL30082026 */
  

  

  return (
    <div className="seuil-page" dir="rtl">
      <BranchLabelBanner branchLabel={branchLabel} />
      <div className="seuil-page-heading">
        <span>إعدادات النجاح</span>
        <h1>عتبة النجاح</h1>
        <p>حدد النقطة التي يعتمد عليها المجلس في تقييم نتائج التلاميذ.</p>
      </div>
      
      <div className="seuil-container">
        {/* Si l'utilisateur est en mode édition */}
        {isEditing ? (
          <>
            <div className="seuil-card-heading">
              <span>قيمة الإعداد</span>
              <h2>أدخل عتبة النجاح</h2>
              <p>أدخل قيمة رقمية ثم أكد العملية.</p>
            </div>
            <input
              type="number"
              placeholder="أدخل عتبة النجاح"
              className="seuil-input"
              value={seuil}
              onChange={(e) => setSeuil(e.target.value)}
            />
            <div className="button-container">
            <button onClick={() => handleGoBack('PageLayout2V2')} className="back-btn">
            <FontAwesomeIcon icon={faArrowLeft} /> رجوع

            </button>
            <button onClick={handleConfirm} className="confirm-btn">تاكيد</button>
            </div>
          </>
        ) : (
          <>
            {/* Affichage du seuil confirmé */}
            <div className="seuil-card-heading">
              <span>القيمة الحالية</span>
              <h2>عتبة النجاح المسجلة</h2>
              <strong className="seuil-value">{seuilConfirme}</strong>
            </div>
            <div className="button-container">
            <button onClick={() => handleGoBack('PageLayout2V2')} className="back-btn">
            <FontAwesomeIcon icon={faArrowLeft} /> رجوع</button>
            <button onClick={handleEdit} className="confirm-btn">تعديل</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LeSeuil;
